import {Datagrid, Filter, FunctionField, TextField, TextInput, TopToolbar} from "react-admin";
import React from "react";
import CrudMod from "../../../Component/Layouts/Button/CrudMod";
import CreateGradientButtonMod from "../../../Component/Layouts/Button/CreateGradientButtonMod";
import ListMod from "../../../Component/Redesign/ListMod";
import {convertedDateWithTime, convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";

const Filters = (props) => (
    <Filter {...props}>
        <TextInput variant="standard" label="Search" source="search" alwaysOn/>
    </Filter>
);

const SubscriptionField = ({record}) => {
    if (!record.subscription) return 'Not Required';
    return (
        <span>{record.subscription === 1 && 'Required'}</span>
    );
}

const PublishedField = ({record}) => {
    if (!record.published) return 'No';
    return (
        <span>{record.published === 1 && 'Yes'}</span>
    );
}

const LocalsField = ({record}) => {
    if (!record.locales || !record.locales.length) {
        return '';
    }

    const lastElement = record.locales.length - 1;
    return record.locales.map((item, i) => (
        <span key={i}>{item.locale}{i === lastElement ? '' : ', '}</span>
    ))
};

export const EventHistories = (props) => {
    const ListActions = ({className}) => {
        return (<TopToolbar className={className}>
            <div className="actionsWrap">
                <div className="addCategoryBtnWrap">
                    <CreateGradientButtonMod label={'Add New Event'}/>
                </div>
            </div>
        </TopToolbar>);
    };

    return (
        <div className="customTableWrap">
            <ListMod {...props} title="Event Histories" filters={<Filters/>} actions={<ListActions/>} resource="event-histories/general"
                     sort={{field: 'order', order: 'ASC'}}>
                <Datagrid bulkActionButtons={false} className="customTable files-table">
                    <FunctionField label="Name" source="name" sortBy="name" render={(record) => {
                        return <span title={record.name}>{record.name}</span>;
                    }}/>
                    <FunctionField label='Description' source="description" sortBy="description" render={(record) => {
                        return (
                            <span title={record.description}>{record.description}</span>
                        );
                    }}/>
                    <TextField label='Order' source="order" sortBy="order"/>
                    <FunctionField label="Visible" source="published" sortBy="published" render={(record) => {
                        return <PublishedField record={record}/>;
                    }}/>
                    <FunctionField label="Start Date" source="start_date" sortBy="start_date" render={(record) => {
                        return (convertedDateWithTimeGMT(record.start_date));
                    }}/>
                    <FunctionField label="End Date" source="end_date" sortBy="end_date" render={(record) => {
                        return (convertedDateWithTimeGMT(record.end_date));
                    }}/>
                    <FunctionField label="Localization" source="locales" sortBy="locales" render={(record) => {
                        return <LocalsField record={record}/>;
                    }}/>
                    <FunctionField label="" source="actions" render={(record) => {
                        return <CrudMod edit="true" del="true" id={record.id} record={record}/>;
                    }}/>
                </Datagrid>
            </ListMod>
        </div>
    )
}

export default EventHistories;
